import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { AuthenticationSelectors } from '../../../auth/state/authentication.selectors';
import { MissedAppointmentsDashboardService } from './state/missed-appointments-dashboard.service';

@Component({
    selector: 'app-dashboard-missed',
    templateUrl: './missed-appointments-widget.component.html'
})
export class MissedAppointmentsWidgetComponent implements OnInit, OnDestroy {
    private subscription: Subscription = new Subscription();
    public currentUser$: Observable<any>;
    missedDashboardWidget$: Observable<any>;
    totalMissedCount$: Observable<number>;
    loading$: Observable<boolean>;
    viewModel$: Observable<any>;

    active = true;

    constructor(
        private store: Store<any>,
        private authenticationSelectors: AuthenticationSelectors,
        private missedDashboardService: MissedAppointmentsDashboardService) {
        // Setup state selectors
        this.currentUser$ = this.authenticationSelectors.selectCurrentUser();
        this.missedDashboardWidget$ = this.missedDashboardService.entities$;
        this.totalMissedCount$ = this.missedDashboardService.totalMissedCount$;
    }

    ngOnInit(): void {
        this.missedDashboardService.clearCache();

        const filters = {
            category: 'missed'
        };
        this.missedDashboardService.subscribeWebSocketJob(filters);

        this.loading$ =  combineLatest([this.missedDashboardService.loading$, this.missedDashboardService.refreshing$])
            .pipe(
                map(([loading, refreshing]) =>
                    loading || refreshing)
            );

        this.viewModel$ = combineLatest(
            [
                this.loading$,
                this.missedDashboardWidget$,
                this.totalMissedCount$]
        )
            .pipe(
                map(([loading, missedDashboardWidget, totalMissedCount]) =>
                    ({loading, missedDashboardWidget, totalMissedCount})
                )
            );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.missedDashboardService.unsubscribeWebSocketJob();
    }
}
